<script setup lang="ts">
import ClientModalMiniature from 'src/pages/(app)/components/clients-list/client-modal-miniature/client-modal-miniature.vue';
import { useClientStore } from 'src/logic/stores/clients.store';

const clientStore = useClientStore();
</script>

<template>
  <template v-if="clientStore.clientMiniaturePopupIsOpened">
    <ClientModalMiniature />
  </template>
</template>
